import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background">
        <span className="flex size-11 animate-pulse items-center justify-center rounded-2xl bg-brand-muted text-brand">
          <ShieldCheck className="size-5" />
        </span>
        <p className="text-sm text-muted-foreground">Verifying your session…</p>
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return <Outlet />;
}
